import Base from "@/controllers/base";
export default class Invoice extends Base {
  constructor(elem) {
    super(elem);
  }

  expandCollapseAll(event) {
    const link = event.target;
    const toShow = /expand all/i.test(link.textContent);
    link.textContent = toShow ? "Collapse All" : "Expand All";
    document.querySelectorAll("table.period a.show-hide").forEach((a) => {
      let target = document.getElementById(a.getAttribute("rel"));
      if (toShow != target.isVisible()) a.click();
    });
  }

  companyChosen(event) {
    event.target
      .closest("form")
      .querySelector('input[type="submit"]').disabled = !event.target.value;
  }

  toggleDriverTypes(event) {
    const chosen = document.getElementById("driver-type-chosen");
    if (event.target.value == "Drivers") {
      chosen.classList.remove("hidden");
    } else {
      chosen.classList.add("hidden");
    }
  }

  agingBy(event) {
    const select = event.target;
    const form = select.closest("form");
    const leader = form.querySelector(".outstanding-filters");
    if (select.value == "issue_date") {
      leader.classList.remove("hidden");
      [...leader.querySelectorAll("input,select")].forEach((input) => {
        input.disabled = false;
      });
    } else {
      leader.classList.add("hidden");
      [...leader.querySelectorAll("input,select")].forEach((input) => {
        input.disabled = true;
      });
    }
  }

  static async markAsUnsent(el) {
    const form = el.closest("form");
    const selected = form.querySelectorAll(
      ".invoices input.invcb[type='checkbox']:checked",
    );
    const ids = [...new Set([...selected].map((input) => input.value))];
    if (ids.length == 0) {
      NApp.flashNoticeOut("Select at least one invoice.");
      return;
    }
    try {
      const response = await fetch("/api/v1/invoices/mark_as_unsent", {
        method: "PUT",
        headers: Base.defaultHeaders,
        body: JSON.stringify({ ids }),
      });
      const body = await response.json();
      if (!response.ok) {
        NApp.flashNoticeOut(
          body.errors || "Could not mark invoices as unsent.",
        );
        return;
      }
      await Invoice.reloadPeriod(form.closest("table.period"));
    } catch (ex) {
      console.log(ex);
    }
  }

  static async reloadPeriod(period) {
    const link = period.querySelector("a.show-hide");
    const url = link?.dataset.turboUrl || link?.getAttribute("href");
    if (!url || url.startsWith("javascript:")) return;
    const response = await fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html, text/html, application/xhtml+xml",
        "X-CSRF-Token": Base.authenticityToken,
      },
    });
    Turbo.renderStreamMessage(await response.text());
    NApp.dispatchTurboLoad();
  }
}
